import API from "./API";

export default class AlternativeContractAPI extends API {
  constructor(parameters = {}) {
    super("/AlternativeContract", parameters);
  }

  getAlternativeContracts(filterData) {
    let url = `${this.endpoint}/Get`;
    let urlParams = '?';

    if (filterData == null) {
      return this.submit("get", url);
    } else {
      for (let key in filterData) {
        if (filterData.hasOwnProperty(key) && filterData[key] != null) {
          urlParams += `${key}=${filterData[key]}&`;
        }
      }

      urlParams = urlParams.slice(0, -1);
      return this.submit("get", `${url}${urlParams}`);
    }
  }

  getAlternativeCount(filterData) {
    let url = `${this.endpoint}/getCount`;
    let urlParams = '?';

    if (filterData == null) {
      return this.submit("get", url);
    } else {
      for (let key in filterData) {
        if (filterData.hasOwnProperty(key) && filterData[key] != null) {
          urlParams += `${key}=${filterData[key]}&`;
        }
      }

      urlParams = urlParams.slice(0, -1);
      return this.submit("get", `${url}${urlParams}`);
    }
  }

  createAlternativeContract(data) {
    return this.submit("post", `${this.endpoint}`, data);
  }

  updateAltContract(data, id) {
    return this.submit("put", `${this.endpoint}?id=${id}`, data);
  }

  getAlternativeContractById(id) {
    return this.submit("get", `${this.endpoint}/${id}`);
  }
}
